import moment from 'moment'
import api from '../components/card/shared/components/history/api'

const state = {
  histories: []
}

// getters
const getters = {
  histories: state => {
    return state.histories
  }
}

// actions
const actions = {

  load ({ commit }, cardId) {
    api.getAllHistories(cardId)
      .then(payload => {
        commit('INSERT_RANGE', payload.data)
      })
  },

  addAssignToUserDesc ({ commit, rootGetters }, user) {
    let currUser = rootGetters['auth/loggedUserAsObj']
    if (user === currUser.fullName) {
      commit('ADD', { user: currUser, desc: 'se juntou a este cartão' })
    } else {
      commit('ADD', { user: currUser, desc: `adicionou o membro ${user} a este cartão` })
    }
  },

  addDueDateDesc ({ commit, rootGetters }, { dueDate, newDate, action }) {
    let currUser = rootGetters['auth/loggedUserAsObj']

    if (action === 'add') {
      commit('ADD', { user: currUser, desc: `adicionou a data de vencimento ${newDate} ao cartão` })
    } else if (action === 'remove') {
      commit('ADD', { user: currUser, desc: `removeu a data de vencimento do cartão` })
    } else {
      commit('ADD', { user: currUser, desc: `alterou a data de vencimento do cartão de ${dueDate} para ${newDate}` })
    }
  },

  addHistories ({ commit }, histories) {
    commit('ADD_RANGE', histories)
  }
}

// mutations
const mutations = {
  ADD (state, history) {
    let now = new Date()
    let tempId = now.getUTCMilliseconds().toString() + state.histories.length.toString()

    state.histories.splice(0, 0, {
      id: tempId,
      user: history.user,
      fullDescription: history.desc,
      dateTime: moment(now).format('DD/MM/YYYY HH:mm')
    })
  },
  INSERT_RANGE (state, list) {
    state.histories = list
  },
  ADD_RANGE (state, list) {
    state.histories = [...list, ...state.histories]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
